import { useMutation } from 'react-query';
import { endOfDay } from 'date-fns';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { ReportType } from '../../flows/profitAndLoss/components/filtersWrapper';

interface IProps {
  customerId: string;
  reportData: any;
  reportType: ReportType;
}

export const useGenerateExpenseReport = ({ reportData, customerId, reportType }: IProps) =>
  useMutation('useGenerateExpenseReport', async () => {
    if (reportData?.period?.endDate) {
      reportData = {
        outputType: reportData.outputType,
        detailedReport: reportType === ReportType.Detailed,
        forceRefresh: true,
        reportPeriod: { ...reportData.period, endDate: endOfDay(new Date(reportData.period.endDate)) },
      };
    }
    const res = await httpService.post(`${BASE_URL}/api/v3/user/${customerId}/expenseReport`, reportData, {
      responseType: 'blob',
    });
    const contentDisposition = res.headers['content-disposition'];
    const filename = contentDisposition.split(';')[1];
    const firstSpliceIdx = filename.indexOf('"');
    const parsedName = filename.substring(firstSpliceIdx + 1, filename.length - 1);
    const IframeUrl = URL.createObjectURL(res.data);
    return { IframeUrl, parsedName };
  });
